import { useQuery } from 'react-query';

import { getPropertiesList } from '@/services/GuestDamage/request';
import { PropertiesList } from '@/services/GuestDamage/types';

type PropertyListHook = () => {
  loading: boolean;
  data: PropertiesList[] | undefined;
};

const usePropertiesList: PropertyListHook = () => {
  const { data, isFetching: loading } = useQuery(
    'property-manager',
    async () => getPropertiesList(),
    {
      refetchOnMount: false,
      refetchInterval: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  );

  return { data, loading };
};

export default usePropertiesList;
